<div class="full-content">
  <ion-content [scrollEvents]="true">
    <router-outlet></router-outlet>
  </ion-content>
</div>

<pptl-help-button></pptl-help-button>
